/**
 * @file template.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el template de la aplicación para animar
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-04-22
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */

"use client";

import { motion } from "framer-motion";

export default function Template({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "easeInOut", duration: 0.75 }}
    >
      {children}
    </motion.div>
  );
}
